import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { PageComponent } from '@shared/components/page/page.component';
import { ContentPageId } from '@shared/models/content-page-ids';
import { LoggerCodes } from '@shared/modules/logger/constants/logger.constants';
import { LoggerService } from '@shared/modules/logger/service/logger.service';
import { AEMService } from '@shared/services/aem/aem.service';
import { ContactInfoContent } from '@shared/services/content/content-jsons/contact-info-content';
import * as fromRootStore from '@store/index';
import { getPersonalDataState } from '@store/index';
import { PersonalDataState } from '@store/reducers/personal-data/personal-data.reducer';
import { formatPhoneNumber } from '@store/selectors/receipt/cashier-nonretirement';
import { switchMap } from 'rxjs';
import {
  selectPersonalAddress,
  selectPersonalPhoneNumber,
  UpdateMobileFlag,
  //UpdatePersonalAddressShowValidation,
  UpdatePhoneNumber,
  VgimPersonalAddressComponent,
  VgimPersonalPhoneComponent,
} from 'vg-interaction-model';

import { ContactinfoRemoteContent } from '../../../../aem/models/ContactinfoRemoteContent';
import { PageContent } from './contact-info-content-mapper';
import { toPageContent } from './contact-info-content-mapper';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
})
export class ContactInfoComponent
  extends PageComponent<ContactinfoRemoteContent, PageContent>
  implements OnInit, OnDestroy, AfterViewInit
{
  isAddressValid = false;
  content = ContactInfoContent;

  personalData: PersonalDataState | undefined;

  @ViewChild(VgimPersonalPhoneComponent) vgimPersonalPhoneComponent:
    | VgimPersonalPhoneComponent
    | undefined;
  @ViewChild(VgimPersonalAddressComponent)
  vgimPersonalAddressComponent: VgimPersonalAddressComponent | undefined;

  constructor(
    protected loggerService: LoggerService,
    globalStore: Store<fromRootStore.State>,
    protected aemService: AEMService,
  ) {
    super(ContentPageId.contactinfo, globalStore, {
      aemService,
      toPageContent,
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.loggerService.info(
      { eventId: 'page-load', message: 'ContactInfo.Load' },
      LoggerCodes.GENERAL_SUCCESS,
    );

    this.subs.add(
      this.globalStore.pipe(select(selectPersonalAddress)).subscribe((personalAddressState) => {
        this.isAddressValid = personalAddressState.validationStatus === 'VALID';
      }),
    );

    this.globalStore.pipe(select(getPersonalDataState)).subscribe((data) => {
      this.personalData = data;
    });
  }

  ngAfterViewInit() {
    if (this.remoteContent$) {
      this.subs.add(
        this.remoteContent$
          .pipe(switchMap(() => this.globalStore.pipe(select(selectPersonalPhoneNumber))))
          .subscribe((phoneNumber) => {
            if (
              this.personalData?.phoneNumber &&
              !phoneNumber &&
              this.vgimPersonalPhoneComponent?.formGroup.pristine
            ) {
              this.globalStore.dispatch(
                UpdatePhoneNumber({ payload: formatPhoneNumber(this.personalData.phoneNumber) }),
              );
              this.globalStore.dispatch(UpdateMobileFlag({ payload: this.personalData.isMobile }));
              this.vgimPersonalPhoneComponent.formGroup.controls.phoneNumber.markAsTouched();
            }
          }),
      );
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  nextPage() {
    if (!this.isAddressValid || !this.vgimPersonalPhoneComponent?.formGroup.valid) {
      this.vgimPersonalAddressComponent?.formGroup.markAllAsTouched();
      this.vgimPersonalPhoneComponent?.formGroup.markAllAsTouched();

      // this no longer works on this version of vgim - alicorn is making updates to fix it
      // this.globalStore.dispatch(new UpdatePersonalAddressShowValidation(true))

      //ignoring these for now since they're going to be covered in the update to the above action
      /* istanbul ignore next */
      this.vgimPersonalAddressComponent?.addressList.first?.addressFormGroup.markAllAsTouched();
      /* istanbul ignore next */
      this.vgimPersonalAddressComponent?.addressList.last?.addressFormGroup.markAllAsTouched();
    } else {
      super.nextPage();
    }
  }
}
